<template>
  <div class="match-empty">
    <img src="@/assets/img/icon/icon_empty.png" alt="icon_empty">
    <br>
    <p>{{title}} 업데이트 전입니다.</p>
  </div>
</template>
<script>
export default {
  name: 'MatchNotFound',
  props: {
    title: {
      type: String,
      default: ''
    },
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>
